/**
 * Share Box Functionality
 *
 * Handles showing/hiding share box on click and generating share links
 */

/* This file has side effects and should not be tree-shaken */
( function() {
	'use strict';

	// Wait for DOM to be ready
	function initShareBox() {
		const shareButtons = document.querySelectorAll( '.share-button' );
		const shareBox = document.getElementById( 'share-box' );
		const shareLinks = shareBox ? shareBox.querySelectorAll( '.share-link' ) : [];

		// Return early if elements don't exist
		if ( ! shareBox || shareButtons.length === 0 ) {
			return;
		}

		let currentButton = null;

		// Generate share URL based on platform
		const getShareUrl = ( platform, url, title ) => {
			const encodedUrl = encodeURIComponent( url );
			const encodedTitle = encodeURIComponent( title );

			switch ( platform ) {
				case 'facebook':
					return `https://www.facebook.com/sharer/sharer.php?u=${ encodedUrl }`;
				case 'twitter':
					return `https://twitter.com/intent/tweet?url=${ encodedUrl }&text=${ encodedTitle }`;
				case 'linkedin':
					return `https://www.linkedin.com/sharing/share-offsite/?url=${ encodedUrl }`;
				case 'whatsapp':
					return `https://wa.me/?text=${ encodedTitle } ${ encodedUrl }`;
				case 'email':
					return `mailto:?subject=${ encodedTitle }&body=${ encodedTitle }%0A%0A${ encodedUrl }`;
				default:
					return url;
			}
		};

		// Position and show share box (fixed to viewport — works on mobile and avoids offset-parent bugs)
		const showShareBox = ( button ) => {
			currentButton = button;
			const postUrl = button.getAttribute( 'data-post-url' );
			const postTitle = button.getAttribute( 'data-post-title' ) || '';

			// Update share links with current post URL
			shareLinks.forEach( ( link ) => {
				const platform = link.getAttribute( 'data-platform' );
				const shareUrl = getShareUrl( platform, postUrl, postTitle );
				link.setAttribute( 'href', shareUrl );
			} );

			const buttonRect = button.getBoundingClientRect();
			const margin = 8;
			const vw = window.innerWidth;
			const vh = window.innerHeight;

			// Measure width while box is still hidden (display:none gives offsetWidth 0).
			shareBox.classList.remove( 'hidden' );
			shareBox.style.visibility = 'hidden';
			shareBox.style.pointerEvents = 'none';
			shareBox.style.position = 'fixed';
			shareBox.style.top = '0';
			shareBox.style.left = '0';
			const shareBoxWidth = shareBox.offsetWidth || shareBox.getBoundingClientRect().width;
			const shareBoxHeight = shareBox.offsetHeight || shareBox.getBoundingClientRect().height;

			// Prefer below the button; flip above if not enough room.
			let top = buttonRect.bottom + margin;
			if ( top + shareBoxHeight > vh - margin ) {
				top = buttonRect.top - shareBoxHeight - margin;
			}
			top = Math.max( margin, Math.min( top, vh - shareBoxHeight - margin ) );

			// Right-align to button (common for share icon on the right); clamp to viewport.
			let left = buttonRect.right - shareBoxWidth;
			left = Math.max( margin, Math.min( left, vw - shareBoxWidth - margin ) );

			shareBox.style.top = `${ top }px`;
			shareBox.style.left = `${ left }px`;
			shareBox.style.visibility = '';
			shareBox.style.pointerEvents = '';

			shareBox.setAttribute( 'aria-hidden', 'false' );
		};

		// Hide share box
		const hideShareBox = () => {
			shareBox.classList.add( 'hidden' );
			shareBox.setAttribute( 'aria-hidden', 'true' );
			shareBox.style.top = '';
			shareBox.style.left = '';
			shareBox.style.visibility = '';
			shareBox.style.pointerEvents = '';
			shareBox.style.position = '';
			currentButton = null;
		};

		// Handle click on share buttons
		shareButtons.forEach( ( button ) => {
			button.addEventListener( 'click', function( event ) {
				event.preventDefault();
				event.stopPropagation();

				// Toggle share box - if clicking the same button, hide it; otherwise show for this button
				if ( currentButton === this && ! shareBox.classList.contains( 'hidden' ) ) {
					hideShareBox();
				} else {
					showShareBox( this );
				}
			} );
		} );

		// Hide share box when clicking outside
		document.addEventListener( 'click', function( event ) {
			if ( ! shareBox.contains( event.target ) && ! event.target.closest( '.share-button' ) ) {
				hideShareBox();
			}
		} );

		// Prevent share box from closing when clicking inside it
		shareBox.addEventListener( 'click', function( event ) {
			event.stopPropagation();
		} );

		// Handle keyboard navigation (Enter/Space on button)
		shareButtons.forEach( ( button ) => {
			button.addEventListener( 'keydown', function( event ) {
				if ( event.key === 'Enter' || event.key === ' ' ) {
					event.preventDefault();
					if ( currentButton === this && ! shareBox.classList.contains( 'hidden' ) ) {
						hideShareBox();
					} else {
						showShareBox( this );
					}
				}

				if ( event.key === 'Escape' ) {
					hideShareBox();
				}
			} );
		} );

		// Handle ESC key to close share box
		document.addEventListener( 'keydown', function( event ) {
			if ( event.key === 'Escape' && ! shareBox.classList.contains( 'hidden' ) ) {
				hideShareBox();
			}
		} );

		// Hide share box when window is resized or scrolled
		const handleHide = () => {
			shareBox.classList.add( 'hidden' );
			shareBox.setAttribute( 'aria-hidden', 'true' );
			shareBox.style.top = '';
			shareBox.style.left = '';
			shareBox.style.visibility = '';
			shareBox.style.pointerEvents = '';
			shareBox.style.position = '';
		};

		window.addEventListener( 'resize', handleHide );
		window.addEventListener( 'scroll', handleHide, true );
	}

	// Initialize when DOM is ready
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initShareBox );
	} else {
		// DOM is already ready
		initShareBox();
	}
}() );

